/* eslint-disable tailwindcss/no-arbitrary-value */
import classNames from 'classnames';
import { CmsImage as CmsImageData } from '../../../types/cmsTypes';
import { CmsImage } from '../../CmsImage';
import { FeLink } from '../../FeLink';

type BannerAioModuleProps = {
  image: CmsImageData;
  url: string;
  /**
   * Rule above the banner, separating it from the product cards. Only drawn
   * when something precedes it — the design has no divider directly under
   * the intro paragraph.
   */
  showTopDivider?: boolean;
};

// Fallback aspect ratio, only used when Strapi returns no dimensions for the
// asset: the widest banner box in the design (942x118 at xl).
const FALLBACK_WIDTH = 942;
const FALLBACK_HEIGHT = 118;

export const BannerAioModule = ({
  image,
  url,
  showTopDivider = false,
}: BannerAioModuleProps): JSX.Element => (
  <FeLink
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    data-component="aio-module-banner"
    className={classNames({
      'block border-t border-borders/default pt-spacing/gap/y': showTopDivider,
    })}
  >
    <CmsImage
      src={image.url}
      alt={image.alternativeText ?? ''}
      width={image.width ?? FALLBACK_WIDTH}
      height={image.height ?? FALLBACK_HEIGHT}
      // Slot widths for `sizes` use CmsImage's own breakpoint names, which do
      // not match Tailwind's: `md` here is min-width 1280, `lg` is 1440.
      sizes={{ _: '100vw', md: '785px', lg: '942px' }}
      className="h-auto max-h-[86px] w-full rounded-radius/button object-contain lg:max-h-25 xl:max-h-[118px]"
    />
  </FeLink>
);
